import type { LoanGoal } from "@/component/SmeLoan/LeadForm/types";
import type { CommonOptions } from "@/shared/ui";

export const LOAN_GOALS: CommonOptions<LoanGoal> = [
	{
		value: "FINANCING",
		label: "működés finanszírozás - folyószámlahitel",
	},
	{
		value: "BUYING_QUOTA",
		label: "üzletrész vásárlás",
	},
	{
		value: "SELA_R_ESTATE",
		label: "ingatlan vásárlás, építés, bővítés",
	},
	{
		value: "BUYING_MACHINE",
		label: "munkagép/eszköz beszerzés",
	},
	{
		value: "OTHER_MEANS",
		label: "egyéb eszköz beszerzése(pl.: szoftver, irodai berendezés)",
	},
	{
		value: "OTHER",
		label: "egyéb beruházás",
	},
	{
		value: "STOCK_FINANCING",
		label: "készlet",
	},
	{
		value: "LOAN_REFINANCING",
		label: "hitelkiváltás",
	},
];
